import {
	Component,
	ChangeDetectionStrategy,
	signal,
	input,
	output,
} from "@angular/core"
import { COMMON_IMPORTS } from "../../common-imports"
import { BtnExtComponent } from "@app/utils/utils.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { PolicyFormFillComponent } from "@app/policy-form-fill/policy-form-fill.component"

@Component({
	selector: "fill-btn",
	imports: [
		COMMON_IMPORTS,
		BtnExtComponent,
		ModalWrapComponent,
		PolicyFormFillComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-btn-ext
			text="fill"
			(clickEv)="modalProps.set({})"
		/>
		@if (modalProps()) {
			<app-modal-wrap
				(onClose)="modalProps.set(null)"
				title="policy_form_fill"
				modalWrapperClass="modal-800"
			>
				<app-policy-form-fill
					(onClose)="modalProps.set(null); $event && filled.emit($event)"
					isModalMode
					[version_id]="latestVersionId()"
					[person_id]="id()"
					[person_type]="type()"
				/>
			</app-modal-wrap>
		}
	`,
})
export class FillBtn {
	modalProps = signal<any>(null)
	id = input.required<any>()
	type = input.required<string>()
	latestVersionId = input.required<any>()
	filled = output()
}
